import { joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

function parseDateToInt(date) {
  date = parseInt(date)
  if (!isNaN(date)) {
    return date
  }
}

export default {
  name: 'ProvidersLogs',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,

      items: []
    }
  },

  computed: {
    id() {
      return this.value?.meta?._routing?.provider
    },

    search() {
      return this.value?.id
    },

    start() {
      const date = new Date(this.value?.createdAt).getTime()

      return parseDateToInt(date / 1000)
    },

    end() {
      const date = new Date(this.value?.updatedAt).getTime() + 5 * 1000

      return parseDateToInt(date / 1000)
    }
  },

  mounted() {
    this.get()
  },

  methods: {
    async get() {
      try {
        this.loading = true

        const data = await request.get(joinURLPath('grafana', 'range'), undefined, {
          data: { id: this.id },
          source: 'loki',
          preset: 'providers_logs',
          start: this.start,
          end: this.end,
          search: this.search,
          params: {
            direction: 'BACKWARD',
            limit: 100
          }
        })

        const result = []
        if (Array.isArray(data) && data.length) {
          data.reduce((result, item) => {
            if (Array.isArray(item) && item.length === 2) {
              result.push(JSON.parse(item[1]))
            }

            return result
          }, result)
          if (Array.isArray(result) && result.length) {
            result.sort((a, b) => {
              return b.time - a.time
            })
          }

          this.items = result
          this.loading = false
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
